// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// COMPONENTS
import StripeConnected from './StripeConnected';
import PaypalConnect from './PaypalConnect';
import poweredByStripeSvg from 'lib/media/powered_by_stripe.svg';
import SectionHeader from 'components/text/SectionHeader';

// APOLLO
// import  ApolloClient from '/imports/ui/apollo/ApolloClient';
// import  { FINISH_CONNECTING_USER } from '/imports/ui/apollo/mutations';
// import  { GET_USER_DATA } from '/imports/ui/apollo/queries';

const Wrapper = ({ children }) => (
  <div style={{ width: 550, maxWidth: '100%', minHeight: 150 }}>
    <SectionHeader>
      PAYMENT SETTINGS
      <img alt="stripe" src={poweredByStripeSvg} style={{ maxHeight: 19, marginLeft: 14 }} />
    </SectionHeader>
    <div style={{ marginTop: 25, minHeight: 50 }}>{children}</div>
  </div>
);

const PaymentsArea = ({ currentUser, orgByUserIdQuery }) => {
  const { stripeUserIdExists } = orgByUserIdQuery.orgByUserId;

  return (
    <Wrapper>
      <div>
        <div style={{ padding: 15 }}>
          <StripeConnected currentUser={currentUser} stripeUserIdExists={stripeUserIdExists} />
        </div>
        <div style={{ padding: 15 }}>
          <PaypalConnect currentUser={currentUser} />
        </div>
      </div>
    </Wrapper>
  );
};

PaymentsArea.defaultProps = {
  currentUser: PropTypes.object.isRequired, // eslint-disable-line
};

export default PaymentsArea;



// WEBPACK FOOTER //
// ./src/routes/app-studio/PaymentsArea/index.js